import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Avatar, Box, Grid, Typography } from '@mui/material'
import { format } from 'date-fns'

import { usePOST_modelAnswerMutation } from 'redux/api/modelAnswersApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { initialValues, validationSchema } from 'utils/formModels/modelAnswerModel'
import CheckboxField from 'components/atoms/fields/CheckboxField'
import RichTextField from 'components/atoms/fields/RichTextField'

interface IProps {
  assignmentId?: string
  onCreate?: any
}

const ModelAnswerForm: FC<IProps> = ({ assignmentId, onCreate }) => {
  const { t } = useTranslation()

  const { text, is_shown_to_students } = formModel()

  const [
    addEntity,
    { isLoading: createLoading, isSuccess: createSuccess, error: createError, data: addResponseData },
  ] = usePOST_modelAnswerMutation()

  useErrorAlert(createError)
  useSuccessAlert(createSuccess ? t('alerts.message-sent') : '')

  useEffect(() => {
    if(createSuccess)
      onCreate();
  }, [createSuccess])


  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {
        addEntity({ assignment_id: assignmentId, body: { 
         ...values
        } })
      }}
    >
      {({ values}) => {
        return (
          <Form>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <RichTextField
                  width={'100%'}
                  fieldProps={{...text}}
                  label={text.label}
                />
              </Grid>
              <Grid item xs={12}>
                <CheckboxField fieldProps={{ ...is_shown_to_students}} />
              </Grid>
              <Grid item xs={12}>
                <SubmitButton
                  color={'success'}
                  text={`${t('common.save')}`}
                  sx={{ width: '150px' }}
                  isLoading={createLoading}
                  alignRight={false}
                />
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default ModelAnswerForm
